/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import objectFitImages from 'object-fit-images'
import './styles.scss'

// ObjectFit PolyFill Doc
// https://github.com/fregante/object-fit-images

class ImageBrowser {
  constructor (element) {
    this.$el = $(element)
    this.$thumbnailsCarousel = this.$el.find('.thumbnails-carousel')
    this.$featuredImage = this.$el.find('.active-product')

    this.initThumbnails()

    // Polyfill needs to load AFTER images
    $(function () { objectFitImages() })
  }

  initThumbnails (params) {
    this.$featuredImage.slick({
      dots: false,
      arrows: false,
      lazyLoad: 'ondemand',
      rows: 0,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      asNavFor: '.thumbnails-carousel'
    })

    this.$thumbnailsCarousel.slick({
      dots: false,
      arrows: true,
      rows: 0, // https://github.com/kenwheeler/slick/issues/3149
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1, // need to scroll one at a time in order to be able to move the focus to the selected image (pretty sure that this is a Slick bug)
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
      asNavFor: '.active-product',

      responsive: [
        {
          breakpoint: 768,
          settings: {
            vertical: false,
            verticalSwiping: false,
            arrows: false,
            slidesToShow: 4
          }
        }
      ]
    })

    $(this.$thumbnailsCarousel).on('afterChange', function () {
      objectFitImages()
    })
  }
}

registerClass('ImageBrowser', ImageBrowser)
